import { Reducer } from 'redux';
import {
  ILongSteelShoppingCartState,
  Types,
  ILongSteelOrderItem
} from './types';

const INITIAL_STATE: ILongSteelShoppingCartState = {
  emitterId: '',
  receiverId: '',
  customerOrder: '',
  items: [],
  typeOfOrder: '',
  screenName: '',
  itemDescription: ''
};

type CustomAction = {
  type: Types;
  payload: {
    longSteelShoppingCartState: ILongSteelShoppingCartState;
    createdOrders: string[];
    typeOfOrder: string;
    screenName: string;
    itemDescription: string;
  };
};

const reducer: Reducer<ILongSteelShoppingCartState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.FINISH_ORDER:
      return {
        ...state,
        createdOrders: [],
        finishOrderLoading: true,
        finishOrderError: false
      };

    case Types.FINISH_ORDER_SUCCESS:
      return {
        ...state,
        createdOrders: action.payload.createdOrders,
        finishOrderLoading: false,
        finishOrderError: false,
        items: [],
        emitterId: '',
        receiverId: ''
      };

    case Types.FINISH_ORDER_FAILURE:
      return { ...state, finishOrderLoading: false, finishOrderError: true };

    case Types.UPDATE_SHOPPING_CART_SETTINGS:
      return {
        ...state,
        ...action.payload.longSteelShoppingCartState,
        items: updateItemWebOrder(
          action.payload.longSteelShoppingCartState.items
        ),
        createdOrders: [],
        finishOrderError: false
      };

    case Types.CLEAN_SHOPPING_CART:
      return { ...INITIAL_STATE };

    case Types.UPDATE_TYPE_OF_ORDER:
      return {
        ...state,
        createdOrders: action.payload.createdOrders,
        typeOfOrder: action.payload.typeOfOrder
      };

    case Types.UPDATE_TAGGING_INFO_PREVIOUS_SCREEN:
      return {
        ...state,

        createdOrders: action.payload.createdOrders,
        screenName: action.payload.screenName,
        itemDescription: action.payload.itemDescription
      };

    case Types.LOAD_FROM_LOCAL_STORAGE:
    default:
      return state;
  }
};

const updateItemWebOrder = (
  items: ILongSteelOrderItem[]
): ILongSteelOrderItem[] => {
  items.forEach((item, idx) => {
    const val = idx + 1;
    item.itemWeb = `${val <= 9 ? '0' : ''}${val}0`;
  });
  return items;
};

export default reducer;
